import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { layoutStore } from 'shared/layout'
import { PlanContainer } from 'pages/settings/ui/BillingPlan/ui/PlanContainer'
import { useCreateContext } from 'pages/clients/pages/create/context/createContext'
import { BreakpointsUpgradeEnum } from 'pages/settings/pages/billing/pages/upgrade/constants/breakpoints'
import { PlanHeader } from 'pages/clients/pages/create/ui/ChoosePlan/PlanHeader/PlanHeader'
import { FranchisePlanSummary } from 'pages/clients/pages/create/ui/ChoosePlan/FranchisePlanSummary/FranchisePlanSummary'
import styles from './styles.module.scss'

export const ChoosePlan = observer(() => {
  const { choosePlanStore, previousStep, nextStep, isFranchise } = useCreateContext()
  const {
    plans,
    selectedValues,
    period,
    additionalSeatPrice,
    additionalNumbersPrice,
    handleSetPeriod,
    setSelectedValue,
    setOnPlanSelected,
  } = choosePlanStore

  useEffect(() => {
    setOnPlanSelected(() => nextStep())
    return () => setOnPlanSelected(null)
  }, [setOnPlanSelected])

  useEffect(() => {
    layoutStore.setBreakpoints(BreakpointsUpgradeEnum)
    return () => layoutStore.setDefault()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <PlanHeader
          period={period}
          handleSetPeriod={handleSetPeriod}
          previousStep={previousStep}
          title={isFranchise ? 'Current plan' : 'Choose your plan'}
          isLastStep={isFranchise}
        />
      </div>
      {isFranchise ? (
        <FranchisePlanSummary />
      ) : (
        <div className={styles.plansContainer}>
          {plans.map((plan) => (
            <PlanContainer
              key={plan.name}
              plan={plan}
              additionalNumberPrice={additionalNumbersPrice}
              additionalSeatPrice={additionalSeatPrice}
              selectedValue={selectedValues[plan.name]}
              onSelectValue={(value, item) => {
                setSelectedValue(plan.name, String(value))
                plan.onSelectValue(value, item)
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
})
